import LocationVideoView from './LocationVideoView';
import { useLocationVideoStreams } from './useLocationVideoStreams';

interface LocationVideoContainerProps {
    clientId: number;
    locationId: number;
}

function LocationVideoContainer({ locationId }: LocationVideoContainerProps) {
    const streams = useLocationVideoStreams(locationId);

    return <LocationVideoView {...streams} />;
}

export default LocationVideoContainer;
export { LocationVideoContainer };
